module.exports = __webpack_public_path__ + "static/media/view1.e9f1f531.jpg";